<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Cash Reconciliation By Employee" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'financeReport', label: 'Finance' },
        {
          name: 'cashReconciliationByEmployee',
          label: 'Cash Reconciliation by Employee',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
        :percentage="percentageCompleted" :filterBySaleType="false" :filterByStoreOrOrg="false" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr>
                <th align="left">Date</th>
                <th align="left">Employee</th>
                <th align="right">Cash Payment</th>
                <th align="right">Debit Payment</th>
                <th align="right">CM Payment</th>
                <th align="right">Gift Card Payment</th>
                <th align="right">Sales Total</th>
                <th align="right">Refunds</th>
              </tr>
            </thead>
            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="(data, index) of formattedData" :key="index" :class="{ total: data.isTotal }">
                <td>{{ data.date }}</td>
                <td v-if="!data.isTotal">{{ data.employeeId }}</td>
                <td v-else>Total</td>
                <td align="right">{{ formatAmount(data.cashPayment + data.cashPaymentReversed) }}</td>
                <td align="right">{{ formatAmount(data.debitPayment + data.debitPaymentReversed) }}</td>
                <td align="right">{{ formatAmount(data.creditMemoPayment + data.creditMemoPaymentReversed) }}</td>
                <td align="right">{{ formatAmount(data.giftCardPayment + data.giftCardPaymentReversed) }}</td>
                <td align="right">{{ formatAmount(data.order + data.orderReversed) }}</td>
                <td align="right">{{ formatAmount(data.orderRefund + data.orderRefundReversed) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import ReportHelper from "@/lib/report/index.js";

export default {
  data() {
    return {
      Utilities,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Cash Reconciliation By Employee");
  },

  computed: {
    ...mapGetters({
      isLoading: "reports/isLoading",
      getData: "reports/getData",
      percentageCompleted: 'reports/percentageCompleted'
    }),
    reportData() {
      return this.getData;
    },
    formattedData() {
      const data = this.reportData;
      let rows = []

      for (let [day, dayValue] of Object.entries(data.list)) {
        for (let [employeeId, employee] of Object.entries(dayValue.employees)) {
          rows.push(employee)
        }
        rows.push({ ...dayValue.total, isTotal: true })
      }

      return rows;
    }
  },
  methods: {
    ...mapActions({
      generateReport: "reports/generate",
      clearData: "reports/clearData",
    }),
    performGetReport(filter) {
      let reportType = "cashReconciliationByEmployee";
      this.generateReport({
        reportType,
        ...filter
      });
    },
    formatAmount(value) {
      return value.toFixed(2)
    },
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "cashReconciliationByEmployee");
    },
  },
  beforeDestroy() {
    this.clearData()
  }
};
</script>

<style lang="scss">
@import "./_cashReconciliationByEmployee.scss";
</style>